import { isEmpty } from 'lodash'

const OTHER_TOOL_OPTION = { id: null, name: 'Outro', isOther: true }

export const ALL_DEPARTMENTS_OPTION = {
  id: 'all',
  name: 'Todos os departamentos',
  isAllDepartments: true,
}

export const isAllDepartmentsSelected = (department) =>
  Array.isArray(department) && department.some((item) => item?.isAllDepartments)

const buildSelectedTool = (aiInventory) => {
  if (!aiInventory) return null
  if (aiInventory.aiInventoryTool) return aiInventory.aiInventoryTool
  return null
}

const buildDepartment = (aiInventory, { guestMode = false } = {}) => {
  if (guestMode) return aiInventory?.departments?.[0] || null
  if (aiInventory?.allDepartments) return [ALL_DEPARTMENTS_OPTION]
  return aiInventory?.departments || []
}

const buildRiskOptionIds = (aiInventory) => {
  if (!aiInventory) return []
  return aiInventory.riskOptionIds || []
}

export const PERSONAL_DATA_VALUES = {
  YES: 'yes',
  NO: 'no',
  UNKNOWN: 'unknown',
}

const toPersonalDataValue = (value) => {
  if (value === true) return PERSONAL_DATA_VALUES.YES
  if (value === false) return PERSONAL_DATA_VALUES.NO
  return PERSONAL_DATA_VALUES.UNKNOWN
}

export const fromPersonalDataValue = (value) => {
  if (value === PERSONAL_DATA_VALUES.YES) return true
  if (value === PERSONAL_DATA_VALUES.NO) return false
  return null
}

export const buildDefaultValues = (
  aiInventory,
  { guestMode = false } = {},
) => ({
  selectedTool: buildSelectedTool(aiInventory),
  toolName: aiInventory?.aiInventoryTool?.name || '',
  providerName: aiInventory?.aiInventoryTool?.aiInventoryProvider?.name || '',
  department: buildDepartment(aiInventory, { guestMode }),
  description: aiInventory?.description || '',
  operationMode: aiInventory?.operationMode || '',
  humanIntervention:
    aiInventory?.humanIntervention === true
      ? 'true'
      : aiInventory?.humanIntervention === false
      ? 'false'
      : '',
  processesPersonalData: toPersonalDataValue(
    aiInventory?.processesPersonalData,
  ),
  riskOptionIds: buildRiskOptionIds(aiInventory),
})

export const buildGeneralInfoPayload = (
  data,
  { fallbackDepartmentId } = {},
) => {
  const isOther = !!data.selectedTool?.isOther && !data.selectedTool?.id

  const allDepartments = isAllDepartmentsSelected(data.department)

  let departmentIds
  if (allDepartments) {
    departmentIds = []
  } else if (Array.isArray(data.department)) {
    departmentIds = !isEmpty(data.department)
      ? data.department.map((department) => Number(department.id))
      : fallbackDepartmentId
      ? [Number(fallbackDepartmentId)]
      : []
  } else {
    const departmentId = data.department?.id || fallbackDepartmentId || null
    departmentIds = departmentId ? [Number(departmentId)] : []
  }

  return {
    aiInventoryToolId: isOther ? null : data.selectedTool?.id || null,
    toolName: isOther ? data.toolName : null,
    providerName: isOther ? data.providerName : null,
    description: data.description || null,
    allDepartments,
    departmentIds,
  }
}

export const buildPurposesPayload = (data) => ({
  operationMode: data.operationMode || null,
  humanIntervention:
    data.humanIntervention === 'true'
      ? true
      : data.humanIntervention === 'false'
      ? false
      : null,
})

export const buildRiskAnalysisPayload = (data) => ({
  processesPersonalData: fromPersonalDataValue(data.processesPersonalData),
  riskOptionIds: data.riskOptionIds || [],
})

export { OTHER_TOOL_OPTION }
